import {Store} from '@effector/effector'
import {Signal} from './shapes/render/index.h'

export function reshape<T, S extends {[field: string]: Function}>(
  store: Store<T>,
  signal: Signal,
  shape: S
): {[K in keyof S]: S[K] extends (val: T) => infer R ? Store<R> : never}
export function reshape<T, S extends {[field: string]: Function}>(
  store: Store<T>,
  shape: S
): {[K in keyof S]: S[K] extends (val: T) => infer R ? Store<R> : never}
export function reshape(store, signal, shape?: any) {
  if (!shape) {
    shape = signal
    signal = null
  }
  const result = {}
  for (const key in shape) {
    result[key] = store.map(shape[key])
  }
  return result
}
